module.exports = __webpack_public_path__ + "static/img/pollo-frito.273a269.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pollo-frito.gif
// module id = pOJ3
// module chunks = 4